module.exports = __webpack_public_path__ + "static/media/refresh-white.7bea9b30.svg";